export default __webpack_public_path__ + "static/media/photo--sm--namrata-3.c7671cc5.jpg";